module.exports = __webpack_public_path__ + "img/thumbnail_Alpaca_f_erythristic.0aeecd2b.png";